<template>
    <div v-if="document" class="sidebar-filters">
        <div class="sidebar-header">
            <div v-if="!hideTitle" class="header-left">
                <i class="dx-icon-info icon-main"></i>
                <span class="sidebar-title">Detalii Document</span>
            </div>
            <div v-else class="header-left"></div>
            <div class="header-actions">
                <DxButton
                    v-if="!readonlyLocal"
                    text="Salvează"
                    icon="save"
                    type="success"
                    styling-mode="contained"
                    class="save-header-btn"
                    @click="saveClicked"
                />
                <DxButton
                    :icon="readonlyLocal ? 'edit' : 'revert'"
                    :styling-mode="readonlyLocal ? 'text' : 'contained'"
                    :type="readonlyLocal ? 'normal' : 'danger'"
                    class="action-btn-small"
                    @click="toggleEdit"
                />
                <DxButton
                    v-if="!hideTitle"
                    icon="close"
                    styling-mode="text"
                    class="close-sidebar-btn-small"
                    @click="$emit('close-sidebar')"
                />
            </div>
        </div>

        <div class="filters-container">
            <DxTabPanel
                :items="tabItems"
                :selected-index="selectedTabIndex"
                @option-changed="onTabPanelOptionChanged"
                :swipe-enabled="false"
                class="filters-tabpanel"
            >
                <template #title="{ data }">
                    <div class="tab-title-wrapper">
                        <i :class="data.icon"></i>
                        <span class="tab-title-text" :class="{ 'tab-title-text--dirty': sectionDirtyCount(data.id) > 0 }">{{ data.title }}</span>
                        <span v-if="sectionDirtyCount(data.id) > 0" class="section-dirty-badge"
                            :title="`${sectionDirtyCount(data.id)} câmp(uri) modificate în această secțiune`">{{ sectionDirtyCount(data.id) }}</span>
                    </div>
                </template>

                <template #item="{ data }">
                    <div class="accordion-item-content">
                        <!-- General -->
                        <div v-if="data.id === 'identity'" class="filter-group-inner">
                            <div class="filter-input">
                                <div class="field-with-revert">
                                    <DxTextBox
                                        label="Număr"
                                        label-mode="floating"
                                        v-model:value="form.Numar"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('Numar') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('Numar')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('Numar')"></i>
                                </div>
                            </div>

                            <!-- Categorie/Tip — ascunse la cererea userului, cod/date păstrate intact -->
                            <div class="filter-input" v-if="false">
                                <DxLookup
                                    label="Categorie"
                                    label-mode="static"
                                    :data-source="dsCategorieDocumente"
                                    value-expr="Id"
                                    display-expr="Nume"
                                    :value="displayCategorieId"
                                    :disabled="true"
                                />
                            </div>

                            <div class="filter-input" v-if="false">
                                <DxLookup
                                    label="Tip"
                                    label-mode="static"
                                    :data-source="dsTipDocumente"
                                    value-expr="Id"
                                    display-expr="Nume"
                                    :value="form.TipId"
                                    :disabled="true"
                                />
                            </div>

                            <div class="filter-input" v-if="tipFlags?.ArePartener === true">
                                <div class="field-with-revert">
                                    <DxLookup
                                        label="Partener"
                                        label-mode="floating"
                                        :data-source="dsPartener"
                                        value-expr="ID"
                                        display-expr="Nume"
                                        v-model:value="form.PartenerId"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('PartenerId') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('PartenerId')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('PartenerId')"></i>
                                </div>
                            </div>

                            <div class="filter-input" v-if="tipFlags?.AreAgentId === true">
                                <div class="field-with-revert">
                                    <DxLookup
                                        label="Agent"
                                        label-mode="floating"
                                        :data-source="dsAgent"
                                        value-expr="Id"
                                        display-expr="Nume"
                                        v-model:value="form.AgentId"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('AgentId') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('AgentId')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('AgentId')"></i>
                                </div>
                            </div>

                            <div class="filter-input">
                                <div class="field-with-revert">
                                    <DxDateBox
                                        label="Data Contabilă"
                                        label-mode="floating"
                                        v-model:value="form.Data"
                                        display-format="dd-MM-yyyy"
                                        type="date"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('Data') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('Data')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('Data')"></i>
                                </div>
                            </div>

                            <div class="filter-input">
                                <div class="field-with-revert">
                                    <DxDateBox
                                        label="Data Document"
                                        label-mode="floating"
                                        v-model:value="form.DataDoc"
                                        display-format="dd-MM-yyyy"
                                        type="date"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('DataDoc') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('DataDoc')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('DataDoc')"></i>
                                </div>
                            </div>

                            <div class="filter-input" v-if="tipFlags?.AreScadenta === true">
                                <div class="field-with-revert">
                                    <DxDateBox
                                        label="Data Scadență"
                                        label-mode="floating"
                                        v-model:value="form.DataScadenta"
                                        display-format="dd-MM-yyyy"
                                        type="date"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('DataScadenta') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('DataScadenta')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('DataScadenta')"></i>
                                </div>
                            </div>
                        </div>

                        <!-- Financiar -->
                        <div v-if="data.id === 'financial'" class="filter-group-inner">
                            <div class="filter-input" v-if="tipFlags?.AreIntrare === true">
                                <div class="field-with-revert">
                                    <DxLookup
                                        label="Gestiune Intrare"
                                        label-mode="floating"
                                        :data-source="dsGestiune"
                                        value-expr="Id"
                                        :display-expr="gestiuneDisplayExpr"
                                        v-model:value="form.GestiuneIntrareId"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('GestiuneIntrareId') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('GestiuneIntrareId')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('GestiuneIntrareId')"></i>
                                </div>
                            </div>

                            <div class="filter-input" v-if="tipFlags?.AreIesire === true">
                                <div class="field-with-revert">
                                    <DxLookup
                                        label="Gestiune Ieșire"
                                        label-mode="floating"
                                        :data-source="dsGestiune"
                                        value-expr="Id"
                                        :display-expr="gestiuneDisplayExpr"
                                        v-model:value="form.GestiuneIesireId"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('GestiuneIesireId') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('GestiuneIesireId')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('GestiuneIesireId')"></i>
                                </div>
                            </div>

                            <div class="filter-input" v-if="tipFlags?.AreBanca === true">
                                <div class="field-with-revert">
                                    <DxLookup
                                        label="Cont Bancă/Casă"
                                        label-mode="floating"
                                        :data-source="dsBanci"
                                        value-expr="Id"
                                        :display-expr="bancaDisplayExpr"
                                        v-model:value="form.ContBancaCasaId"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('ContBancaCasaId') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('ContBancaCasaId')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('ContBancaCasaId')"></i>
                                </div>
                            </div>

                            <div class="form-field-grid">
                                <div class="field-with-revert" v-if="tipFlags?.AreValuta === true">
                                    <DxLookup
                                        label="Valută"
                                        label-mode="floating"
                                        :data-source="dsValute"
                                        value-expr="Id"
                                        display-expr="Simbol"
                                        v-model:value="form.ValutaId"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('ValutaId') }"
                                        @value-changed="onValutaChanged"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('ValutaId')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('ValutaId')"></i>
                                </div>

                                <DxNumberBox
                                    v-if="tipFlags?.AreValuta === true"
                                    label="Curs"
                                    label-mode="floating"
                                    :value="form.Curs"
                                    format="#,##0.0000"
                                    :disabled="true"
                                />

                                <div class="field-with-revert" v-if="tipFlags?.AreAdaos === true">
                                    <DxNumberBox
                                        label="Adaos (%)"
                                        label-mode="floating"
                                        v-model:value="form.Adaos"
                                        format="#0.00'%'"
                                        :min="0" :max="100"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('Adaos') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('Adaos')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('Adaos')"></i>
                                </div>

                                <DxNumberBox
                                    v-if="tipFlags?.AreValoare === true"
                                    label="Valoare"
                                    label-mode="floating"
                                    :value="viewDoc.Valoare"
                                    format="#,##0.00"
                                    :disabled="true"
                                />

                                <div class="field-with-revert" v-if="tipFlags?.AreTva === true">
                                    <DxNumberBox
                                        label="TVA %"
                                        label-mode="floating"
                                        v-model:value="form.Tva"
                                        format="#0"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('Tva') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('Tva')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('Tva')"></i>
                                </div>

                                <DxNumberBox
                                    v-if="tipFlags?.AreValoare === true && tipFlags?.AreTva === true"
                                    label="Valoare TVA"
                                    label-mode="floating"
                                    :value="viewDoc.ValoareTva"
                                    format="#,##0.00"
                                    :disabled="true"
                                />

                                <DxNumberBox
                                    v-if="tipFlags?.AreValoare === true && tipFlags?.AreTva === true"
                                    label="Total"
                                    label-mode="floating"
                                    :value="viewDoc.Total"
                                    format="#,##0.00"
                                    :disabled="true"
                                />

                                <DxNumberBox
                                    v-if="tipFlags?.AreValoare === true && tipFlags?.CrossCateg !== 0"
                                    label="Sold"
                                    label-mode="floating"
                                    :value="viewDoc.Sold"
                                    format="#,##0.00"
                                    :disabled="true"
                                />
                            </div>
                        </div>

                        <!-- Referințe -->
                        <div v-if="data.id === 'logistics'" class="filter-group-inner">
                            <div class="filter-input" v-if="tipFlags?.AreProiect === true">
                                <div class="field-with-revert">
                                    <DxLookup
                                        label="Proiect"
                                        label-mode="floating"
                                        :data-source="dsProiecte"
                                        value-expr="Id"
                                        display-expr="Nume"
                                        v-model:value="form.ProiectId"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('ProiectId') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('ProiectId')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('ProiectId')"></i>
                                </div>
                            </div>

                            <div class="filter-input" v-if="tipFlags?.AreContract === true">
                                <div class="field-with-revert">
                                    <DxLookup
                                        label="Contract"
                                        label-mode="floating"
                                        :data-source="dsNumereContracte"
                                        value-expr="Id"
                                        display-expr="NumeContract"
                                        v-model:value="form.ContractId"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('ContractId') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('ContractId')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('ContractId')"></i>
                                </div>
                            </div>

                            <div class="filter-input" v-if="tipFlags?.AreComanda === true">
                                <div class="field-with-revert">
                                    <DxLookup
                                        label="Comandă"
                                        label-mode="floating"
                                        :data-source="dsComenzi"
                                        value-expr="Id"
                                        display-expr="Cod"
                                        v-model:value="form.ComandaId"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('ComandaId') }"
                                        @value-changed="onComandaIdChanged"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('ComandaId')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('ComandaId')"></i>
                                </div>
                            </div>

                            <div class="filter-input" v-if="tipFlags?.AreLotFabricatie === true">
                                <div class="field-with-revert">
                                    <DxLookup
                                        label="Lot Fabricație"
                                        label-mode="floating"
                                        :data-source="dsLoturiFabricatie"
                                        value-expr="Id"
                                        display-expr="Cod"
                                        v-model:value="form.LotFabricatieId"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('LotFabricatieId') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('LotFabricatieId')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('LotFabricatieId')"></i>
                                </div>
                            </div>

                            <div class="filter-input" v-if="tipFlags?.AreStructIdEditabil === true">
                                <div class="field-with-revert">
                                    <DxLookup
                                        label="Structură Editabilă"
                                        label-mode="floating"
                                        :data-source="dsStructuriIdEditabile"
                                        value-expr="Id"
                                        display-expr="Nume"
                                        v-model:value="form.StructIdEditabil"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('StructIdEditabil') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('StructIdEditabil')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('StructIdEditabil')"></i>
                                </div>
                            </div>

                            <div class="filter-input" v-if="tipFlags?.AreDocument === true">
                                <div class="field-with-revert">
                                    <DxLookup
                                        label="Document Asociat"
                                        label-mode="floating"
                                        :data-source="dsDocumenteAsociate"
                                        value-expr="Id"
                                        display-expr="Numar"
                                        v-model:value="form.DocGeneratAutomatId"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('DocGeneratAutomatId') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('DocGeneratAutomatId')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('DocGeneratAutomatId')"></i>
                                </div>
                            </div>
                        </div>

                        <!-- Aprobare & Stare -->
                        <div v-if="data.id === 'status'" class="filter-group-inner">
                            <div class="filter-input">
                                <div class="field-with-revert">
                                    <DxLookup
                                        label="Aprobă"
                                        label-mode="floating"
                                        :data-source="dsPerEmployees"
                                        value-expr="Id"
                                        :display-expr="perEmployeeDisplayExpr"
                                        v-model:value="form.AprobaId"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('AprobaId') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('AprobaId')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('AprobaId')"></i>
                                </div>
                            </div>
                            <div class="checkbox-grid">
                                <DxCheckBox
                                    text="Anulat"
                                    v-model:value="form.Anulat"
                                    :disabled="readonlyLocal"
                                />
                                <DxCheckBox
                                    v-if="tipFlags?.AreIntrare === true || tipFlags?.AreIesire === true || tipFlags?.EsteCreanta === true || tipFlags?.EsteObligatie === true"
                                    text="Stornat/Retur"
                                    v-model:value="form.StornatRetur"
                                    :disabled="readonlyLocal"
                                />
                                <DxCheckBox
                                    v-if="tipFlags?.EsteCreanta === true || tipFlags?.EsteObligatie === true"
                                    text="Autofacturat"
                                    v-model:value="form.Autofacturat"
                                    :disabled="readonlyLocal"
                                />
                                <DxCheckBox
                                    v-if="tipFlags?.EsteCreanta === true || tipFlags?.EsteObligatie === true"
                                    text="Emis Terț"
                                    v-model:value="form.EmisTert"
                                    :disabled="readonlyLocal"
                                />
                            </div>
                        </div>

                        <!-- Notes -->
                        <div v-if="data.id === 'notes'" class="filter-group-inner">
                            <div class="filter-input" v-if="tipFlags?.AreExplicatie === true">
                                <div class="field-with-revert field-with-revert--top">
                                    <DxTextArea
                                        label="Explicație"
                                        label-mode="floating"
                                        v-model:value="form.Explicatie"
                                        :height="80"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('Explicatie') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('Explicatie')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('Explicatie')"></i>
                                </div>
                            </div>

                            <div class="filter-input" v-if="tipFlags?.AreObservatii === true">
                                <div class="field-with-revert field-with-revert--top">
                                    <DxTextArea
                                        label="Observații"
                                        label-mode="floating"
                                        v-model:value="form.Observatii"
                                        :height="80"
                                        :disabled="readonlyLocal"
                                        :class="{ 'field-dirty': !readonlyLocal && isDirty('Observatii') }"
                                    />
                                    <i v-if="!readonlyLocal && isDirty('Observatii')" class="dx-icon dx-icon-revert field-revert-icon"
                                        title="Revenire la valoarea inițială" @click="revertField('Observatii')"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </DxTabPanel>
        </div>

    </div>
</template>

<script>
import DxTabPanel from 'devextreme-vue/tab-panel';
import DxTextBox from 'devextreme-vue/text-box';
import DxNumberBox from 'devextreme-vue/number-box';
import DxLookup from 'devextreme-vue/lookup';
import DxDateBox from 'devextreme-vue/date-box';
import DxTextArea from 'devextreme-vue/text-area';
import DxCheckBox from 'devextreme-vue/check-box';
import DxButton from 'devextreme-vue/button';
import DataSource from 'devextreme/data/data_source';
import AppSetting from '@/settings/appSettings';
import DOC_Documente from '@/services/Documente/DOC_Documente';
import PRO_LoturiFabricatie from '@/services/Documente/PRO_LoturiFabricatie';
import notify from 'devextreme/ui/notify';

export default {
    name: 'DocumentDetails',
    components: {
        DxTabPanel,
        DxTextBox,
        DxNumberBox,
        DxLookup,
        DxDateBox,
        DxTextArea,
        DxCheckBox,
        DxButton
    },
    props: {
        document: {
            type: Object,
            required: false,
            default: null
        },
        hideTitle: {
            type: Boolean,
            default: false
        },
        isReadonly: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            readonlyLocal: this.isReadonly,
            selectedTabIndex: 0,
            tabItems: [
                { id: 'identity', title: 'General', icon: 'dx-icon-card' },
                { id: 'financial', title: 'Financiar', icon: 'dx-icon-money' },
                { id: 'logistics', title: 'Referințe', icon: 'dx-icon-box' },
                { id: 'status', title: 'Aprobare & Stare', icon: 'dx-icon-check' },
                { id: 'notes', title: 'Note', icon: 'dx-icon-comment' }
            ],

            tipFlags: null,
            form: this.getEmptyForm(),
            originalForm: null,

            dsCategorieDocumente: null,
            dsTipDocumente: null,
            dsPartener: null,
            dsAgent: null,
            dsValute: null,
            dsGestiune: null,
            dsNumereContracte: null,
            dsProiecte: null,
            dsCursValutar: null,
            dsBanci: null,
            dsComenzi: null,
            dsLoturiFabricatie: null,
            dsStructuriIdEditabile: null,
            dsPerEmployees: null,
            dsDocumenteAsociate: null
        };
    },
    computed: {
        viewDoc() {
            const d = this.document || {};

            return {
                ...d,
                CategorieId: d.CategorieId ?? d.CategorieID ?? null,
                Tva: d.Tva ?? d.TVA ?? 0,
                ValoareTva: d.ValoareTva ?? d.ValoareTVA ?? 0
            };
        },
        displayCategorieId() {
            if (!this.readonlyLocal) {
                return this.form.CategorieId ?? this.viewDoc.CategorieId ?? null;
            }

            return this.viewDoc.CategorieId ?? null;
        }
    },
    watch: {
        document: {
            async handler(newVal) {
                this.syncFormFromDocument(newVal);
                if (this.dsValute) {
                    await this.resolveValutaId();
                }
                if (this.dsTipDocumente) {
                    await this.loadTipFlags(this.form.TipId);
                }
                this.filterByPartener(this.form.PartenerId);
                if (this.tipFlags?.AreLotFabricatie === true) {
                    await this.loadLoturiFabricatie(this.form.ComandaId);
                }
            },
            immediate: true
        },
        isReadonly(newVal) {
            this.readonlyLocal = newVal;
        },
        form: {
            deep: true,
            handler() {
                this.emitDirtyCount();
            }
        }
    },
    async mounted() {
        this.initDataSources();
        await this.resolveValutaId();
        await this.loadTipFlags(this.form.TipId);
        this.filterByPartener(this.form.PartenerId);
        if (this.tipFlags?.AreLotFabricatie === true) {
            await this.loadLoturiFabricatie(this.form.ComandaId);
        }
    },
    methods: {
        getEmptyForm() {
            return {
                TipId: null,
                CategorieId: null,
                Numar: '',
                Data: null,
                DataDoc: null,
                DataScadenta: null,
                PartenerId: null,
                ValutaId: null,
                Curs: 1,
                Tva: 0,
                ContractId: null,
                ComandaId: null,
                LotFabricatieId: null,
                ProiectId: null,
                GestiuneIntrareId: null,
                GestiuneIesireId: null,
                GestionarIntrareId: null,
                GestionarIesireId: null,
                AgentId: null,
                StructIdEditabil: null,
                DocGeneratAutomatId: null,
                ContBancaCasaId: null,
                Adaos: null,
                AprobaId: null,
                Anulat: false,
                StornatRetur: false,
                Autofacturat: false,
                EmisTert: false,
                Explicatie: '',
                Observatii: ''
            };
        },

        toDate(value) {
            return value ? new Date(value) : null;
        },

        // Trimiterea unui obiect Date brut serializează implicit în UTC (Date.toISOString()) —
        // miezul nopții la ora României (UTC+2/+3) devine ora 21-22 din ziua PRECEDENTĂ în UTC,
        // iar backendul nu reconvertește la ora locală înainte de a tăia ora — rezultă data
        // salvată cu o zi în urmă (bug confirmat 2026-07-31, comparat cu documentul din desktop).
        // Trimițând "YYYY-MM-DD" din componentele LOCALE ale Date-ului eliminăm ambiguitatea.
        toDateOnlyString(d) {
            if (!d) return null;
            const dt = new Date(d);
            const yyyy = dt.getFullYear();
            const mm = String(dt.getMonth() + 1).padStart(2, '0');
            const dd = String(dt.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        },

        syncFormFromDocument(source) {
            const doc = source || {};

            this.form = {
                TipId: doc.TipId ?? null,
                CategorieId: doc.CategorieId ?? doc.CategorieID ?? null,
                Numar: doc.Numar ?? '',
                Data: this.toDate(doc.Data),
                DataDoc: this.toDate(doc.DataDoc),
                DataScadenta: this.toDate(doc.Scadenta),
                PartenerId: doc.PartenerId ?? doc.PartenerID ?? null,
                ValutaId: doc.ValutaId ?? doc.ValutaID ?? null,
                Curs: doc.Curs ?? 1,
                Tva: doc.Tva ?? doc.TVA ?? 0,
                ContractId: doc.ContractId ?? doc.ContractID ?? null,
                ComandaId: doc.ComandaId ?? doc.ComandaID ?? null,
                LotFabricatieId: doc.LotFabricatieId ?? doc.LotFabricatieID ?? null,
                ProiectId: doc.ProiectId ?? doc.ProiectID ?? null,
                GestiuneIntrareId: doc.GestiuneIntrareId ?? doc.GestiuneIntrareID ?? null,
                GestiuneIesireId: doc.GestiuneIesireId ?? doc.GestiuneIesireID ?? null,
                GestionarIntrareId: doc.GestionarIntrareId ?? doc.GestionarIntrareID ?? null,
                GestionarIesireId: doc.GestionarIesireId ?? doc.GestionarIesireID ?? null,
                AgentId: doc.AgentId ?? doc.AgentID ?? null,
                StructIdEditabil: doc.StructIdEditabil ?? doc.StructIDEditabil ?? null,
                DocGeneratAutomatId: doc.DocGeneratAutomatId ?? null,
                ContBancaCasaId: doc.ContBancaCasaId ?? doc.ContBancaCasaID ?? null,
                Adaos: doc.Adaos ?? null,
                AprobaId: doc.AprobaId ?? doc.AprobaID ?? null,
                Anulat: doc.Anulat ?? false,
                StornatRetur: doc.StornatRetur ?? false,
                Autofacturat: doc.Autofacturat ?? false,
                EmisTert: doc.EmisTert ?? false,
                Explicatie: doc.Explicatie ?? '',
                Observatii: doc.Observatii ?? ''
            };
        },

        initDataSources() {
            const authHeader = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('ERA_Jwt')
            };

            this.dsCategorieDocumente = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'DOC_Categorii',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsTipDocumente = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'DOC_Tipuri',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsPartener = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'PAR_Parteneri',
                    key: 'ID',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsAgent = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'COM_Agenti',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsValute = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            // Vezi nota din DocumenteView.vue — Gestiune Intrare/Ieșire vine din ERP_StructuraCompanie
            // filtrat DOAR pe EsteVizibil=true (NU și EsteGestiune — verificat pe ERA_MidasoftTst,
            // legacy permite orice nod vizibil, nu doar cele marcate gestiune).
            this.dsGestiune = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'ERP_StructuraCompanie',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                },
                filter: ['EsteVizibil', '=', true],
            });

            this.dsNumereContracte = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'COM_Contracte',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsProiecte = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'DOC_Proiecte',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsCursValutar = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_CursValutar',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    fieldTypes: {
                        ValutaID: 'Guid'
                    },
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsBanci = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'ERP_BanciConturi',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsComenzi = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'PRO_Comenzi',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsStructuriIdEditabile = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'ERP_StructuraCompanie',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsPerEmployees = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'PER_Employees',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });

            this.dsDocumenteAsociate = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'DOC_Documente',
                    key: 'Id',
                    keyType: 'Guid',
                    version: 4,
                    beforeSend: (e) => e.headers = authHeader
                }
            });
        },

        bancaDisplayExpr(item) {
            return item ? `${item.Nume}${item.CodIban ? ' — ' + item.CodIban : ''}` : '';
        },

        perEmployeeDisplayExpr(item) {
            return item ? `${item.Surname ?? ''} ${item.Name ?? ''}`.trim() : '';
        },

        onTabPanelOptionChanged(e) {
            if (e.name === 'selectedIndex') {
                this.selectedTabIndex = e.value;
            }
        },

        async loadTipFlags(tipId) {
            if (!tipId || !this.dsTipDocumente) {
                this.tipFlags = null;
                return;
            }
            try {
                this.tipFlags = await this.dsTipDocumente.store().byKey(tipId);
            } catch (error) {
                console.error('Eroare la încărcarea flag-urilor tipului de document:', error);
                this.tipFlags = null;
            }
        },

        // Ca in legacy (DOC_DocumentForm: RowEditComanda_EditValueChanged) — lista de loturi de fabricatie
        // se filtreaza pe comanda selectata; fara comanda, se afiseaza toate loturile nescoase din uz.
        async loadLoturiFabricatie(comandaId) {
            try {
                let items = [];
                if (comandaId) {
                    const resp = await PRO_LoturiFabricatie.getByComanda(comandaId);
                    items = resp.data ?? [];
                } else {
                    const resp = await PRO_LoturiFabricatie.getAllActive();
                    items = resp.data?.value ?? [];
                }
                this.dsLoturiFabricatie = new DataSource({ store: { type: 'array', data: items, key: 'Id' } });
            } catch (error) {
                console.error('Eroare la încărcarea loturilor de fabricație:', error);
                this.dsLoturiFabricatie = new DataSource({ store: { type: 'array', data: [], key: 'Id' } });
            }
        },

        onComandaIdChanged(e) {
            if (this.tipFlags?.AreLotFabricatie === true) {
                this.loadLoturiFabricatie(e.value);
            }
        },

        filterByPartener(partenerId) {
            if (this.dsComenzi) {
                this.dsComenzi.filter(partenerId ? ['ClientId', '=', partenerId] : null);
                this.dsComenzi.reload();
            }
            if (this.dsDocumenteAsociate) {
                const filters = [['PartenerId', '=', partenerId]];
                if (this.viewDoc?.Id) filters.push('and', ['Id', '<>', this.viewDoc.Id]);
                this.dsDocumenteAsociate.filter(partenerId ? filters : null);
                this.dsDocumenteAsociate.reload();
            }
        },

        async resolveValutaId() {
            if (this.form.ValutaId || !this.document?.Valuta) return;
            try {
                this.dsValute.filter(['Simbol', '=', this.document.Valuta]);
                const result = await this.dsValute.load();
                if (result?.length > 0) {
                    this.form.ValutaId = result[0].Id;
                }
            } catch (e) { /* silent */ }
        },

        async onValutaChanged(e) {
            this.form.ValutaId = e.value;

            if (!e.value) {
                this.form.Curs = 1;
                return;
            }

            try {
                this.dsCursValutar.filter(['ValutaID', '=', e.value]);
                this.dsCursValutar.sort([{ selector: 'Data', desc: true }]);
                this.dsCursValutar.pageSize(1);

                const result = await this.dsCursValutar.load();

                if (result && result.length > 0) {
                    this.form.Curs = result[0].Curs;
                    return;
                }

                const valuta = await this.dsValute.store().byKey(e.value);
                this.form.Curs = valuta?.Curs ?? 1;
            } catch (error) {
                console.error('Eroare la încărcarea cursului valutar:', error);
                this.form.Curs = 1;
            }
        },

        toggleEdit() {
            if (!this.readonlyLocal) {
                this.syncFormFromDocument(this.document);
                this.originalForm = null;
                this.readonlyLocal = true;
                this.emitDirtyCount();
                return;
            }

            this.originalForm = { ...this.form };
            this.readonlyLocal = false;
        },

        enableEdit() {
            this.originalForm = { ...this.form };
            this.readonlyLocal = false;
        },

        // ── Revert per câmp — identic ca tipar cu Personal/GeneralTab.vue (markEditor +
        // field-dirty), adaptat la câmpuri legate manual prin v-model (nu DxForm) ──
        normalizeForCompare(value) {
            return value instanceof Date ? value.getTime() : value;
        },

        isDirty(field) {
            if (!this.originalForm) return false;
            return this.normalizeForCompare(this.form[field]) !== this.normalizeForCompare(this.originalForm[field]);
        },

        revertField(field) {
            if (!this.originalForm) return;
            this.form[field] = this.originalForm[field];
            // Câmp derivat legat: revenirea la Valuta originală trebuie să aducă
            // înapoi și Cursul derivat din ea (altfel rămâne pe valoarea intermediară).
            if (field === 'ValutaId') this.form.Curs = this.originalForm.Curs;
            this.emitDirtyCount();
        },

        // Legacy afișează "Nume - Descr" (ERP_StructuraCompanieRecursiv.sql: "nume+' - '+descr as CodNume") —
        // câmpul brut "Nume" e de fapt codul scurt, denumirea reală e în "Descr".
        gestiuneDisplayExpr(item) {
            if (!item) return '';
            return item.Descr ? `${item.Nume ?? ''} - ${item.Descr}`.replace(/^ - /, '') : (item.Nume ?? '');
        },

        emitDirtyCount() {
            if (!this.originalForm) {
                this.$emit('dirty-count-change', 0);
                return;
            }
            const fields = Object.keys(this.originalForm);
            const count = fields.filter((f) => this.isDirty(f)).length;
            this.$emit('dirty-count-change', count);
        },

        // ── Contor modificări per secțiune acordeon (vizibil și cu secțiunea închisă) ──
        sectionDirtyCount(sectionId) {
            if (!this.originalForm) return 0;
            const fieldsBySection = {
                identity: ['Numar', 'PartenerId', 'AgentId', 'Data', 'DataDoc', 'DataScadenta'],
                financial: ['GestiuneIntrareId', 'GestiuneIesireId', 'ContBancaCasaId', 'ValutaId', 'Adaos', 'Tva'],
                logistics: ['ProiectId', 'ContractId', 'ComandaId', 'LotFabricatieId', 'StructIdEditabil', 'DocGeneratAutomatId'],
                status: ['AprobaId', 'Anulat', 'StornatRetur', 'Autofacturat', 'EmisTert'],
                notes: ['Explicatie', 'Observatii']
            };
            const fields = fieldsBySection[sectionId] ?? [];
            return fields.filter((f) => this.isDirty(f)).length;
        },

        async saveClicked() {
            if (this.tipFlags?.AreStructIdEditabil === true && !this.form.StructIdEditabil) {
                notify('Selectați structura (departamentul)!', 'error', 5000);
                return;
            }
            if (this.tipFlags?.AreIntrare === true && !this.form.GestiuneIntrareId) {
                notify('Selectați gestiunea de intrare!', 'error', 5000);
                return;
            }
            if (this.tipFlags?.AreIesire === true && !this.form.GestiuneIesireId) {
                notify('Selectați gestiunea de ieșire!', 'error', 5000);
                return;
            }
            try {
                const payload = {
                    TipId: this.form.TipId,
                    Numar: this.form.Numar,
                    Data: this.toDateOnlyString(this.form.Data),
                    PartenerId: this.form.PartenerId,
                    DataScadenta: this.toDateOnlyString(this.form.DataScadenta),
                    ValutaId: this.form.ValutaId,
                    Curs: this.form.Curs,
                    ContractId: this.form.ContractId,
                    ComandaId: this.form.ComandaId,
                    LotFabricatieId: this.form.LotFabricatieId,
                    ProiectId: this.form.ProiectId,
                    GestiuneIntrareId: this.form.GestiuneIntrareId,
                    GestiuneIesireId: this.form.GestiuneIesireId,
                    GestionarIntrareId: this.form.GestionarIntrareId,
                    GestionarIesireId: this.form.GestionarIesireId,
                    DataDoc: this.toDateOnlyString(this.form.DataDoc),
                    AgentId: this.form.AgentId,
                    Explicatie: this.form.Explicatie,
                    Observatii: this.form.Observatii,
                    TVA: this.form.Tva ?? 0,
                    StructIdEditabil: this.form.StructIdEditabil,
                    DocGeneratAutomatId: this.form.DocGeneratAutomatId,
                    ContBancaCasaId: this.form.ContBancaCasaId,
                    Adaos: this.form.Adaos,
                    AprobaId: this.form.AprobaId,
                    Anulat: this.form.Anulat,
                    StornatRetur: this.form.StornatRetur,
                    Autofacturat: this.form.Autofacturat,
                    EmisTert: this.form.EmisTert
                };

                await DOC_Documente.update(this.viewDoc.Id, payload);

                notify('Modificările au fost salvate.', 'success', 2000);
                this.readonlyLocal = true;
                this.originalForm = null;
                this.emitDirtyCount();
                this.$emit('refresh-document', this.viewDoc.Id);
            } catch (error) {
                console.error('Error saving document details:', error);
                notify('Eroare la salvarea documentului.', 'error', 4000);
            }
        }
    }
};
</script>

<style scoped>
.sidebar-filters {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.sidebar-header {
    padding: 18px 20px;
    border-bottom: 1px solid #f1f5f9;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.icon-main {
    font-size: 18px;
    color: #ff2c21;
    background: rgba(255, 44, 33, 0.1);
    padding: 6px;
    border-radius: 8px;
}

.sidebar-title {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
}

.close-sidebar-btn-small {
    color: #64748b !important;
    width: 32px !important;
    height: 32px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 8px !important;
    margin-right: -8px;
}

.close-sidebar-btn-small:hover {
    background-color: #fee2e2 !important;
    color: #ef4444 !important;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 6px;
}

.save-header-btn {
    height: 30px !important;
    font-size: 12px !important;
    border-radius: 8px !important;
}

.action-btn-small {
    width: 32px !important;
    height: 32px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    border-radius: 8px !important;
}

.action-btn-small:hover {
    background-color: #f1f5f9 !important;
}

.filters-container {
    flex-grow: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 10px 0;
}

.filters-tabpanel {
    padding: 0 10px;
}

.tab-title-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 2px;
}

.tab-title-wrapper i {
    color: #64748b;
    font-size: 15px;
}

.tab-title-text {
    font-weight: 600;
    color: #1e293b;
    font-size: 13px;
}

.tab-title-text--dirty {
    color: #b91c1c !important;
}

.section-dirty-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    margin-left: 2px;
    border-radius: 999px;
    background: #ef4444;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
}

.accordion-item-content {
    padding: 15px 10px 20px 10px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    border-top: 1px solid #f8fafc;
}

.filter-group-inner {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

/* ── Revert per câmp — paletă identică cu Personal/GeneralTab.vue (.field-dirty) ── */
.field-with-revert {
    display: flex;
    align-items: center;
    gap: 6px;
}

.field-with-revert > *:first-child {
    flex: 1;
    min-width: 0;
}

.field-with-revert--top {
    align-items: flex-start;
}

.field-with-revert--top .field-revert-icon {
    margin-top: 10px;
}

.field-revert-icon {
    flex-shrink: 0;
    font-size: 16px;
    color: #ef4444;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
}

.field-revert-icon:hover {
    background: #fee2e2;
}

:deep(.field-dirty.dx-texteditor) {
    border: 1px solid #ef4444 !important;
    background: #fff1f2 !important;
    border-radius: 4px;
}

:deep(.field-dirty .dx-texteditor-input) {
    color: #b91c1c !important;
    font-weight: 600;
}

.filter-input {
    display: flex;
    flex-direction: column;
}

.form-field-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}

.checkbox-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
}

.mt-2 {
    margin-top: 8px;
}

.sidebar-footer {
    padding: 20px;
    border-top: 1px solid #f1f5f9;
    background: #fff;
    flex-shrink: 0;
}

.dx-state-disabled {
    opacity: 1 !important;
}

.sidebar-search-btn {
    width: 100% !important;
    height: 44px !important;
    background-color: #ff2c21 !important;
    color: white !important;
    border-radius: 10px !important;
    font-weight: 600 !important;
    box-shadow: 0 4px 12px rgba(255, 44, 33, 0.2) !important;
    transition: all 0.2s ease !important;
}

.sidebar-search-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 44, 33, 0.3) !important;
}

:deep(.dx-tabpanel-tabs) {
    margin-bottom: 8px;
}

:deep(.dx-tab) {
    border-radius: 8px !important;
}

:deep(.dx-texteditor) {
    border-radius: 8px;
    background-color: #fcfcfc;
}

:deep(.dx-lookup-field-wrapper) {
    padding: 0 8px;
}
</style>